export default "__VITE_ASSET__Ss8YXcYp__"